import { HttpContextToken } from '@angular/common/http';

/** Permite a las vistas nuevas tratar status y cuerpo sin el diálogo heredado. */
export const PRESERVE_HTTP_ERROR = new HttpContextToken<boolean>(() => false);

/** La vista muestra su propio indicador; no agrega headers a las llamadas. */
export const SKIP_GLOBAL_SPINNER = new HttpContextToken<boolean>(() => false);
